import React from "react";
import { Car, FileCheck2, Wrench, Sparkles, Building2, ShieldCheck, Hash, Truck } from "lucide-react";

const ITEMS = [
  { icon: ShieldCheck, title: "STK a emise", text: "Kompletní zajištění STK a měření emisí bez čekání a zbytečného stresu." },
  { icon: FileCheck2, title: "Evidenční kontroly", text: "Evidenční kontrola vozidla pro přepisy, dovoz i změny v registru." },
  { icon: Car, title: "Přepisy vozidel", text: "Přepisy, změny vlastníka a registrace vozidel vyřídíme rychle za vás." },
  { icon: Hash, title: "Převozní značky", text: "Zajistíme převozní značky pro dovoz, vývoz i jiné účely." },
  { icon: ShieldCheck, title: "Pojištění aut", text: "Srovnání a sjednání výhodného pojištění vozidel na míru." },
  { icon: Wrench, title: "Autoservis", text: "Servisní práce pro všechny značky vozidel. Kvalitně, poctivě a za férové ceny." },
  { icon: Sparkles, title: "Čištění DPF", text: "Profesionální čištění DPF filtrů pro lepší výkon a nižší emise." },
  { icon: Truck, title: "Odtah vozidla", text: "Odtah vozidla po poruše či nehodě. Nonstop pomoc po celém Znojemsku." },
];

export default function Services() {
  return (
    <section
      id="sluzby"
      data-testid="services-section"
      className="relative bg-[#0A0D17] text-white py-24 lg:py-32 overflow-hidden"
    >
      <div className="absolute inset-0 hero-grid opacity-50" />
      <div className="relative max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center max-w-3xl mx-auto">
          <span className="text-xs uppercase tracking-[0.22em] text-amber-300 font-semibold">
            Naše služby
          </span>
          <h2 className="font-heading mt-4 text-3xl sm:text-4xl lg:text-5xl font-bold leading-tight tracking-tight">
            STK Komfort — auto služby pro Znojmo a okolí
          </h2>
          <p className="font-body mt-5 text-lg text-slate-300">
            STK Komfort™ je lokální auto asistenční služba pro Znojmo a okolí. Pomáháme občanům,
            seniorům, firmám a živnostníkům se zajištěním STK, emisí, evidenčních kontrol,
            přepisů vozidel, převozních značek, pojištění, autoservisu, čištění interiéru,
            DPF filtrů, polepů a odtahu. Šetříme klientům čas, cesty, čekání a zbytečnou administrativu.
          </p>
        </div>

        <div className="mt-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {ITEMS.map((it) => (
            <ServiceCard key={it.title} {...it} />
          ))}
        </div>
      </div>
    </section>
  );
}

function ServiceCard({ icon: Icon, title, text }) {
  return (
    <a
      href="#cenik"
      data-testid={`service-card-${title}`}
      className="group relative rounded-3xl border border-amber-300/15 bg-white/[0.03] p-7 backdrop-blur-sm transition-all hover:-translate-y-1 hover:border-amber-300/35 hover:bg-white/[0.06]"
    >
      <div className="flex h-12 w-12 items-center justify-center rounded-2xl bg-amber-300/10 border border-amber-300/20 text-amber-300">
        <Icon className="h-5 w-5" />
      </div>
      <div className="font-heading mt-6 text-lg font-bold text-white">{title}</div>
      <p className="mt-3 text-sm text-slate-400 leading-relaxed">{text}</p>
      <div className="mt-6 inline-flex items-center gap-1.5 text-xs font-semibold text-amber-300/90 group-hover:text-amber-200">
        Více informací →
      </div>
    </a>
  );
}
